/**
 * Retourne l'URL de base de l'API backend.
 * 
 * En développement :
 * - Si VITE_API_URL n'est pas défini, utilise "http://localhost:4000"
 * - Le proxy Vite (/api) ne fonctionne pas pour les redirections complètes de page
 * 
 * En production :
 * - Utilise VITE_API_URL défini dans le Dockerfile (ex: https://api.ziyara.site)
 */
export function getApiUrl(): string {
  return import.meta.env.VITE_API_URL || "http://localhost:4000";
}

/**
 * Retourne l'URL complète pour un endpoint de l'API.
 * 
 * @param endpoint - Le chemin de l'endpoint (ex: "/auth/google", "/api/me")
 * @returns L'URL complète (ex: "https://api.ziyara.site/auth/google" ou "http://localhost:4000/auth/google")
 */
export function getApiEndpoint(endpoint: string): string {
  const baseUrl = getApiUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
}
